import { useQueryClient } from '@tanstack/react-query';

import { useToastedMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type {
  CreateTrustRelationshipRequest,
  OIDCTrustRelationship,
} from '../../../../shared/model-typings/oidctrustrelationship';

import { AVAILABLE_SERVICE_ACCOUNTS_QUERY_KEY } from './useAvailableServiceAccounts';
import { TRUST_RELATIONSHIPS_QUERY_KEY } from './useTrustRelationships';

/**
 * Hook to create a new OIDC trust relationship.
 */
export default function useCreateTrustRelationship() {
  const queryClient = useQueryClient();

  return useToastedMutation({
    mutationFn: async (request: CreateTrustRelationshipRequest) => {
      const { data } = await post<CreateTrustRelationshipRequest, OIDCTrustRelationship>(
        '/api/oidc/trust-relationships',
        request,
      );
      return data;
    },
    onSuccess: (data) => {
      // Invalidate trust relationships list
      queryClient.invalidateQueries({ queryKey: [TRUST_RELATIONSHIPS_QUERY_KEY, { providerId: data?.providerId }] });
      queryClient.invalidateQueries({ queryKey: [TRUST_RELATIONSHIPS_QUERY_KEY, { userId: data?.userId }] });
      queryClient.invalidateQueries({ queryKey: [AVAILABLE_SERVICE_ACCOUNTS_QUERY_KEY, data?.providerId] });
    },
    successToastMessage: 'Trust relationship created successfully',
    errorToastMessage: 'Failed to create trust relationship',
  });
}
